import { observable, computed, action, makeObservable } from 'mobx';
import { dominosStore } from '../../../main';
import { showInfoPopup } from '../../../modules/InfoPopup';
import { recombeeAddToCart } from '../../elements/Recombee';
import { goFish } from '../api';
import { 
    dataLayerPush, 
    createLayerSingleProduct, 
    createLayerSimpleProduct, 
    createGA4LayerSimpleProduct, 
    createLayerPizzaProduct, 
    createLayerCreatorProduct, 
    createLayerPromotionProduct, 
    createLayerProducts,
    createGA4LayerPizzaProduct
} from '../datalayers/datalayers';
import { getAppDefaultMessage } from '../dictionary';
import { isOrderStatus } from '../navigation';
import { DominosRootStore } from './index';
import { prepareProductsForInsider } from '../../utils/prepareProductsForInsider';
import {
    createGA4LayerImpressions as newCreateGA4LayerImpressions,
    dataLayerPush as newDataLayerPush,
    createTagsString,
    createLayerProducts as newCreateLayerProducts
} from '../datalayers/newdatalayers';
import { getPizzaOptionsAsString } from '../../../modules/OrderSummupDelivery/helpers';

import { getConfig } from '../../../modules/AppMain/config';

import { productTypes } from '../datalayers/datalayers';

const getCategoryNameByGuid = (guid: string): string => {
    const { categories, navigation } = getConfig();
    if (navigation && navigation.length > 0) {
        const navItem = navigation.find(item => item.guid === guid);
        if (navItem) {
            return navItem.text;
        }
    }
    return categories[guid] || 'opakowanie';
};

const getItemCategory2 = (categoryGuid: string | null, documentName?: string): string => {
    if (documentName === 'Creator') {
        return 'Pizza';
    }
    const { categories } = getConfig();
    return categoryGuid ? (categories[categoryGuid] || 'opakowanie') : 'opakowanie';
};

const sendViewCartEvent = (cartStore: any): void => {
    const localguid = cartStore.dominosStore.localStore.localId;
    if (!localguid) {
        return;
    }
    newCreateLayerProducts({ localguid, products: cartStore.products }).then(items => {
        const finalItems = (items || []).map((item, index) => {
            const cartProduct = cartStore.products[index];
            const cartId = cartProduct && 'CartId' in cartProduct.Data ? cartProduct.Data.CartId : null;
            const isUpsellCartItem = cartId ? sessionStorage.getItem(`cart_${cartId}_is_upsell`) === '1' : false;
            const isUpsellByProductSource = sessionStorage.getItem(`upsell_source_${item.item_id}`) === '1';
            const storedItemListNameFromCart = cartId ? sessionStorage.getItem(`cart_${cartId}_item_list_name`) : null;
            const storedItemListNameFromProduct = sessionStorage.getItem(`product_${item.item_id}_item_list_name`);
            const itemListName = (isUpsellCartItem || isUpsellByProductSource)
                ? 'Cart'
                : (storedItemListNameFromCart || storedItemListNameFromProduct || item.item_list_name || '');

            return {
                ...item,
                item_category2: item.item_category2,
                item_category3: item.item_category3 || '',
                item_list_name: itemListName,
                index: index + 1,
                item_variant: item.item_variant || ''
            };
        });
        newDataLayerPush({
            eventName: "view_cart",
            ecommerce: {
                currency: 'PLN',
                value: cartStore.totalSum,
                items: finalItems
            }
        });
    });
};

const isCartPage = (): boolean => {
    const { root, routes } = getConfig();
    const currentPath = window.location.pathname;
    const cartRoute = root ? root + routes.cart : routes.cart;
    return currentPath === cartRoute || 
           currentPath === routes.cart || 
           currentPath.endsWith(routes.cart);
};

declare global {
    interface Window {
        makeElementHidden: (products: string[]) => void;
    }
}

export class CartStore {
    dominosStore: DominosRootStore;
    /**
     * All cart products merget into array
     *
     * @type {AppCartProduct[]}
     * @memberof CartStore
     */
    @observable.ref products: AppCartProduct[] = [];
    /**
     * Cart total price
     *
     * @memberof CartStore
     */
    @observable total = 0;
    /**
     * Cart MinimalOrderValue
     *
     * @memberof CartStore
     */
    @observable MinimalOrderValue = 0;
    /**
     * Cart DistanceToPremises
     *
     * @memberof CartStore
     */
    @observable DistanceToPremises = 0;
    /** Cart totalSum price
     *
     * @memberof CartStore
     */
    @observable totalSum = 0;
    /**
     * Cart deliveryFee price
     *
     * @memberof CartStore
     */
    @observable deliveryFee: CartDeliveryFeeResponse;
    /**
     * Initial loading state
     *
     * @memberof CartStore
     */
    @observable loading = true;
    /**
     * Loading/working state
     *
     * @memberof CartStore
     */
    @observable working = false;
    /**
     * Used by cloud 'cart added'
     *
     * @type {Partial<AppProduct>}
     * @memberof CartStore
     */
    @observable.ref activeProduct: Partial<AppProduct>;
    /**
     * Special mode for configurator/creator
     * e.g.: prevent from adding more than 1 pizza
     *
     * @memberof CartStore
     */
    @observable configuratorPromotionMode = false;

    @observable cartError = '';

    /**
     * Used to hide products within A/B tests
     *
     * @type {string[]} array of product names
     * @memberof CartStore
     */
    @observable.ref hiddenFromOutsideProducts: string[] = [];

    activeProductTimeout: number;
    getProductCounter = 0;
    cartId: string;

    creatorId: string;

    // plastic Packaging fee in summary 

    Package: {
        Text: string;
        PopupText: HTMLElement;
        Cost: number;
        Button: string;
        Id: string;
    };
    // CARDBOARD Packaging fee in summary 

    CartonPackage: {
        Text: string;
        PopupText: HTMLElement;
        Cost: number;
        Button: string;
        Id: string;
    };
    // CARDBOARD Pizza Packaging fee in summary 

    CartonPackagePizza: {
        Text: string;
        PopupText: HTMLElement;
        Cost: number;
        Button: string;
        Id: string;
    };
    
    Packages: [
    ];


    // Last category while switching menu navigation items
    currentMenuCategory: string | undefined;

    /**
     * Used as a temporary container for getsummary response when validating it in cart.
     * Do not use it elsewhere.
     *
     * @type {SummaryResponse}
     * @memberof CartStore
     */
    summaryResponse: SummaryResponse;

    /**
     * Throttle to many calls. Value shouldn't be higher than 2-3 seconds.
     *
     * @memberof CartStore
     */
    getCartTimer = 0;
    getCartTimerDelay = 2000;

    /**
     * Creates an instance of CartStore.
     * @param {DominosRootStore} store
     * @memberof CartStore
     */
    constructor(store: DominosRootStore) {
        makeObservable(this);

        this.dominosStore = store;

        window.makeElementHidden = (products: string[]) => {
            this.updateHiddenProducts(products);
        };
    }

    @action updateHiddenProducts = (products: string[]) => {
        this.hiddenFromOutsideProducts = products;
    };

    @action getCart = () => {
        // Check if we can get cart now
        if (!this.getCartTimer) {
            // Start timer to kill to many calls
            this.getCartTimer = window.setTimeout(() => {
                this.getCartTimer = 0;
            }, this.getCartTimerDelay);
            // Get cart data
            this.working = true;
            return goFish({ api: 'getcart' }).then(
                (response: CartResponse) => {
                    this.manageCartResponse(response);
                    return response
                },
                (response: CartResponse) => {
                    this.manageCartResponseFail(response)
                    return response
                }
            );
        }
        // To soon after last request so do nothing
        else {
            return Promise.resolve({ Status: true, Code: '', Message: '' });
        }
    };

    @action clearCart = () => {
        this.products = [];
    };

    @action manageCartResponse = (response: CartResponse): string => {
        if (response.Status) {
            this.cartError = '';
            this.products = this.mergeProducts(response);

            this.total = response.Sum;
            this.MinimalOrderValue = response.MinimalOrderValue;
            this.DistanceToPremises = response.DistanceToPremises;
            this.totalSum = response.TotalSum;
            this.deliveryFee = response.DeliveryFee;
            this.Package = response.Package;
            this.Packages = response.Packages;
            this.CartonPackage = response.CartonPackage;
            this.CartonPackagePizza = response.CartonPackagePizza;
            if (this.cartId !== response.CartId) {
                this.cartId = response.CartId;
            }
        }
        this.working = false;
        return response.Status ? '' : response.Message || getAppDefaultMessage('errors.default');
    };

    @action manageCartResponseFail = (response: CartResponse): string => {
        this.working = false;
        if (response.Code === '500') {
            this.cartError = getAppDefaultMessage('errors.cart');
        }
        return response.Message || getAppDefaultMessage('errors.server');
    };

    @action setCurrentMenuCategory = (currentCategory: string) => {
        this.currentMenuCategory = currentCategory || undefined;
    };
    /**
     * Puts all back-end product types into one array of AppCartProduct
     *
     * @param {CartResponse} resp
     * @returns {AppCartProduct[]}
     * @memberof CartStore
     */
    mergeProducts = (resp: CartResponse): AppCartProduct[] => {
        const prods: AppCartProduct[] = [];

        resp.CartProducts.map(p => {
            prods.push({ Type: 98, Data: { ...p } });
        });

        resp.CartPizzas.map(p => {
            prods.push({ Type: 1, Data: { ...p } });
        });

        resp.CartCoupons.map(p => {
            prods.push({ Type: 2, Data: { ...p } });
        });

        resp.CartCreators.map(p => {
            prods.push({ Type: 99, Data: { ...p } });
        });

        return prods;
    };

    /**
     * Add/remove simple product. Depends on quantity. To remove provide quantity with minus e.g.: -1.
     *
     * @param {string} id
     * @param {number} quantity
     * @param {number} price
     * @param {string} name
     * @returns {string}
     * @memberof CartStore
     */
    @action addToCart = (
        id: string,
        quantity: number,
        price: number,
        name: string,
        recommId: string
    ) => {
        this.working = true;
        const isUpsellFromCart = Boolean(recommId) || sessionStorage.getItem(`upsell_source_${id}`) === '1';
        return goFish({
            api: 'addproduct',
            data: { Id: id, Count: quantity }
        }).then((resp: CartResponse) => {
            this.manageCartResponse(resp);
            if (resp.Status) {
                // add product to cart in recombee
                resp.CartProducts.map(prod => {
                    if (id === prod.Id) {
                        recombeeAddToCart(prod.DocumentName, quantity, recommId);
                        sessionStorage.setItem('recommId_' + prod.DocumentName, recommId);
                    }
                });
                this.generateActiveProduct(
                    id,
                    name,
                    Math.round(price * 100 * quantity) / 100,
                    quantity
                );

                prepareProductsForInsider({
                    products: this.products,
                    localguid: this.dominosStore.localStore.localId,
                }).then(prods => {
                    window.InsiderQueue = [];
                    window.InsiderQueue.push({
                        type: 'currency',
                        value: 'PLN'
                    });
                    window.InsiderQueue.push({
                        type: quantity > 0 ? 'add_to_cart' : 'remove_from_cart',
                        value: {
                            total: this.totalSum,
                            items: prods
                        }
                    });
                    window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
                });
                
                if (quantity > 0) {
                    dataLayerPush(
                        'ee_add',
                        {},
                        {
                            add: {
                                actionField: {
                                    list: this.currentMenuCategory
                                },
                                products: [createLayerSimpleProduct(name, price, quantity)]
                            }
                        }
                    );

                    const prodToAddToCart = this.products.find(prod => prod.Data.Id === id);

                    if (prodToAddToCart) {
                        const categoriesGuid = 'CategoriesGuid' in prodToAddToCart.Data 
                            ? prodToAddToCart.Data.CategoriesGuid 
                            : [];
                        const categoryGuid = categoriesGuid && categoriesGuid.length > 0 
                            ? categoriesGuid[0] 
                            : null;

                        const storedIndex = sessionStorage.getItem(`product_${id}_index`);
                        const productIndex = storedIndex ? parseInt(storedIndex, 10) : (this.products.findIndex(p => p.Data.Id === id) !== -1 ? this.products.findIndex(p => p.Data.Id === id) + 1 : 1);
                        
                        const storedItemListName = sessionStorage.getItem(`product_${id}_item_list_name`);
                        const itemListNameFromProduct = isUpsellFromCart
                            ? 'Cart'
                            : (storedItemListName || (isCartPage() ? 'Cart' : getCategoryNameByGuid(categoryGuid)));
                        
                        if (prodToAddToCart.Data.CartId && itemListNameFromProduct) {
                            sessionStorage.setItem(`cart_${prodToAddToCart.Data.CartId}_item_list_name`, itemListNameFromProduct);
                            if (isUpsellFromCart) {
                                sessionStorage.setItem(`cart_${prodToAddToCart.Data.CartId}_is_upsell`, '1');
                            }
                        }
                        
                        const itemListName = prodToAddToCart.Data.CartId 
                            ? (sessionStorage.getItem(`cart_${prodToAddToCart.Data.CartId}_item_list_name`) || itemListNameFromProduct)
                            : itemListNameFromProduct;

                        // przystawki
                        newDataLayerPush({
                            eventName: "add_to_cart",
                            ecommerce: {
                                currency: 'PLN',
                                value: prodToAddToCart.Data.Sum,
                                items: [createGA4LayerSimpleProduct(
                                    id,                                                          // id
                                    name,                                                        // name
                                    productIndex,                                                // index (z view_item_list/select_item lub fallback)
                                    'Dominos',                                                   // item_brand
                                    productTypes[98],                                            // item_category
                                    isCartPage() ? 'Cart' : itemListName,                        // item_list_name (z CartId lub fallback)
                                    getItemCategory2(categoryGuid, prodToAddToCart.Data.DocumentName),  // item_category2
                                    '',                                                          // item_category3
                                    name,                                                        // item_variant
                                    price,                                                       // price
                                    quantity                                                     // count
                                )],
                                minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                            }
                        });
                        
                        if (isCartPage()) {
                            sendViewCartEvent(this);
                        }
                    }

                } else {
                    dataLayerPush(
                        'ee_remove',
                        {},
                        {
                            remove: {
                                products: [createLayerSimpleProduct(name, price, quantity)]
                            }
                        }
                    );

                    newDataLayerPush({
                        eventName: "remove_from_cart",
                        ecommerce: {
                            currency: 'PLN',
                            value: [createLayerSimpleProduct(name, price, quantity)]
                        }
                    });
                    
                }

                return '';
            } else {
                const msg = resp.Message || getAppDefaultMessage('errors.default');
                showInfoPopup({
                    subtitle: getAppDefaultMessage('errors.popupHeader'),
                    text: msg,
                    button: getAppDefaultMessage('errors.popupBtn')
                });
                return msg;
            }
        }, this.manageCartResponseFail);
    };

    /**
     * Add/remove simple product. Depends on quantity. To remove provide quantity with minus e.g.: -1.
     *
     * @param {string} id
     * @param {number} quantity
     * @param {number} price
     * @param {string} name
     * @returns {string}
     * @memberof CartStore
     */
    @action AddProductToConversion = (price: number) => {
        this.working = true;
        return goFish({
            api: 'addconversion',
            data: { Price: price }
        }).then((resp: CartResponse) => {
            this.working = false;
            if (resp.Status) {
                return '';
            } else {
                const msg = resp.Message || getAppDefaultMessage('errors.default');
                return msg;
            }
        }, this.manageCartResponseFail);
    };

    /**
     * Removes product from cart completely by CartId
     *
     * @param {string} CartId
     * @memberof CartStore
     */
    @action removeFromCart = (CartId: string) => {
        const prod = this.cartProduct(CartId);
        if (prod) {
            this.working = true;
            return goFish({
                api: 'delproduct',
                data: { CartId }
            }).then((resp: CartResponse) => {
                this.manageCartResponse(resp);
                if (resp.Status) {
                    prepareProductsForInsider({
                        products: this.products,
                        localguid: this.dominosStore.localStore.localId,
                    }).then(prods => {
                        window.InsiderQueue = [];
                        window.InsiderQueue.push({
                            type: 'currency',
                            value: 'PLN'
                        });
                        window.InsiderQueue.push({
                            type: 'remove_from_cart',
                            value: {
                                total: this.totalSum,
                                items: prods
                            }
                        });
                        
                        if (!this.products.length) {
                            window.InsiderQueue.push({
                                type: 'cart_cleared'
                            });
                        }
                        window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
                    });
                    dataLayerPush(
                        'ee_remove',
                        {},
                        {
                            remove: {
                                products: [createLayerSingleProduct(prod)]
                            }
                        }
                    );
                    
                    const categoriesGuid = 'CategoriesGuid' in prod.Data ? prod.Data.CategoriesGuid : [];
                    const categoryGuid = categoriesGuid && categoriesGuid.length > 0 ? categoriesGuid[0] : null;
                    
                    const storedItemListNameFromCart = sessionStorage.getItem(`cart_${CartId}_item_list_name`);
                    const storedItemListNameFromProduct = sessionStorage.getItem(`product_${prod.Data.Id}_item_list_name`);
                    const itemListName = storedItemListNameFromCart || storedItemListNameFromProduct || (isCartPage() ? 'Cart' : getCategoryNameByGuid(categoryGuid));
                    
                    const storedIndex = sessionStorage.getItem(`product_${prod.Data.Id}_index`);
                    const productIndex = storedIndex ? parseInt(storedIndex, 10) : 1;
                    
                    let itemVariant = '';
                    if ('Options' in prod.Data && prod.Data.Options && prod.Data.Options.length > 0) {
                        itemVariant = (prod.Data.Options as CartProductResponse[])
                            .filter(opt => opt.Count > 0)
                            .map(opt => opt.Name)
                            .join(', ');
                    }
                    
                    if (prod.Type === 1) {
                        goFish({
                            api: 'getproductlist',
                            data: { localguid: this.dominosStore.localStore.localId }
                        }).then((response: any) => {
                            const productFromList = response.Status && response.Product 
                                ? response.Product.find((p: any) => p.Id === prod.Data.Id)
                                : null;
                            const productTags = createTagsString(productFromList?.Tags);
                            
                            let pizzaVariant = '';
                            if ('Size' in prod.Data && 'Flavor' in prod.Data) {
                                pizzaVariant = `${prod.Data.Name.toUpperCase()}, ${getPizzaOptionsAsString(prod.Data)}`;
                            }
                            
                            newDataLayerPush({
                                eventName: "remove_from_cart",
                                ecommerce: {
                                    currency: 'PLN',
                                    value: prod.Data.Sum,
                                    items: [createGA4LayerPizzaProduct(
                                        prod.Data.Id,
                                        prod.Data.Name,
                                        productIndex,
                                        'Dominos',
                                        productTypes[1],
                                        isCartPage() ? 'Cart' : itemListName,
                                        getItemCategory2(categoryGuid, prod.Data.DocumentName),
                                        productTags || '',
                                        pizzaVariant,
                                        prod.Data.Price,
                                        prod.Data.Count
                                    )]
                                }
                            });
                        }).catch(() => {
                            let pizzaVariant = '';
                            if ('Size' in prod.Data && 'Flavor' in prod.Data) {
                                pizzaVariant = `${prod.Data.Name.toUpperCase()}, ${getPizzaOptionsAsString(prod.Data)}`;
                            }
                            
                            newDataLayerPush({
                                eventName: "remove_from_cart",
                                ecommerce: {
                                    currency: 'PLN',
                                    value: prod.Data.Sum,
                                    items: [createGA4LayerPizzaProduct(
                                        prod.Data.Id,
                                        prod.Data.Name,
                                        productIndex,
                                        'Dominos',
                                        productTypes[1],
                                        isCartPage() ? 'Cart' : itemListName,
                                        getItemCategory2(categoryGuid, prod.Data.DocumentName),
                                        '',
                                        pizzaVariant,
                                        prod.Data.Price,
                                        prod.Data.Count
                                    )]
                                }
                            });
                        });
                    } else {
                        newDataLayerPush({
                            eventName: "remove_from_cart",
                            ecommerce: {
                                currency: 'PLN',
                                value: prod.Data.Sum,
                                items: [createGA4LayerSimpleProduct(
                                    prod.Data.Id,
                                    prod.Data.Name,
                                    productIndex,
                                    'Dominos',
                                    productTypes[prod.Type],
                                    isCartPage() ? 'Cart' : itemListName,
                                    getItemCategory2(categoryGuid, prod.Data.DocumentName),
                                    '',
                                    itemVariant || prod.Data.Name,
                                    prod.Data.Price,
                                    prod.Data.Count
                                )]
                            }
                        });
                    }
                    
                    this.generateActiveProduct(
                        prod.Data.Id,
                        prod.Data.Name,
                        Math.round(prod.Data.Price * 100 * prod.Data.Count) / 100,
                        -prod.Data.Count
                    );
                    // Additional info about removed product
                    if (resp.Message) {
                        showInfoPopup({ text: resp.Message });
                    }
                    return '';
                } else {
                    const msg = resp.Message || getAppDefaultMessage('errors.default');
                    showInfoPopup({
                        subtitle: getAppDefaultMessage('errors.popupHeader'),
                        text: msg,
                        button: getAppDefaultMessage('errors.popupBtn')
                    });
                    return msg;
                }
            }, this.manageCartResponseFail);
        }

        return Promise.resolve('');
    };

    /**
     * Add pizza from configurator
     *
     * @param {string} name
     * @param {number} totalPrice
     * @param {CartPizzaProduct} pizza
     * @returns
     * @memberof CartStore
     */
    @action addPizzaToCart = (
        name: string,
        totalPrice: number,
        pizza: CartPizzaProduct,
        analyticsOptions: CartProductResponse[],
        analyticsSizeName: string,
        analyticsFlavorName: string
    ) => {
        if (this.configuratorPromotionMode && this.dominosStore.promoStore.promotionPizzaId) {
            return this.dominosStore.promoStore.addPizza(
                name,
                pizza,
                analyticsOptions,
                analyticsSizeName,
                analyticsFlavorName
            );
        }
        // Pizza from pizza menu category so add into cart
        else {
            this.working = true;
            return goFish({
                api: 'addpizza',
                data: { ...pizza }
            }).then((resp: CartResponse) => {
                this.manageCartResponse(resp);
                if (resp.Status) {
                    // add simple configurator pizza to cart in recombee
                    resp.CartPizzas.map(prod => {
                        if (prod.Id === pizza.Id) {
                            recombeeAddToCart(prod.DocumentName, pizza.Count);
                        }
                    });

                    // item_added_to_cart
                    const addedPizza = resp.CartPizzas.find(
                        prod => prod.Id === pizza.Id
                    );

                    prepareProductsForInsider({
                        products: this.products,
                        localguid: this.dominosStore.localStore.localId,
                    }).then(prods => {
                        window.InsiderQueue = [];
                        window.InsiderQueue.push({
                            type: 'currency',
                            value: 'PLN'
                        });
                        window.InsiderQueue.push({
                            type: 'add_to_cart',
                            value: {
                                total: this.totalSum,
                                items: prods
                            }
                        });
                        window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
                    });
                    this.generateActiveProduct(pizza.Id, name, totalPrice, pizza.Count);
                    dataLayerPush(
                        'ee_add',
                        {},
                        {
                            add: {
                                actionField: {
                                    list: this.currentMenuCategory
                                },
                                products: [
                                    createLayerPizzaProduct(
                                        pizza,
                                        name,
                                        totalPrice,
                                        analyticsOptions,
                                        analyticsSizeName,
                                        analyticsFlavorName
                                    )
                                ]
                            }
                        }
                    );

                    const addedProduct = this.products.find(p => p.Data.Id === pizza.Id);

                    if (addedProduct) {
                        const categoriesGuid = 'CategoriesGuid' in addedProduct.Data 
                            ? addedProduct.Data.CategoriesGuid 
                            : [];
                        const categoryGuid = categoriesGuid && categoriesGuid.length > 0 
                            ? categoriesGuid[0] 
                            : null;
                        
                        const { categories } = getConfig();

                        let itemVariant = '';
                        if ('Options' in addedProduct.Data && addedProduct.Data.Options && addedProduct.Data.Options.length > 0) {
                            itemVariant = (addedProduct.Data.Options as CartProductResponse[])
                                .filter(opt => opt.Count > 0)
                                .map(opt => opt.Name)
                                .join(', ');
                        }

                        const id = pizza.Id;
                        const quantity = pizza.Count;
                        const price = quantity > 0 ? totalPrice / quantity : totalPrice;

                        const storedIndex = sessionStorage.getItem(`product_${id}_index`);
                        const productIndex = storedIndex ? parseInt(storedIndex, 10) : 1;
                        
                        const storedItemListName = sessionStorage.getItem(`product_${id}_item_list_name`);
                        const itemListNameFromProduct = storedItemListName || (isCartPage() ? 'Cart' : getCategoryNameByGuid(categoryGuid));
                        
                        if (addedProduct.Data.CartId && itemListNameFromProduct) {
                            sessionStorage.setItem(`cart_${addedProduct.Data.CartId}_item_list_name`, itemListNameFromProduct);
                        }
                        
                        const itemListName = addedProduct.Data.CartId 
                            ? (sessionStorage.getItem(`cart_${addedProduct.Data.CartId}_item_list_name`) || itemListNameFromProduct)
                            : itemListNameFromProduct;

                        // pizza
                        const pizzaProduct = createLayerPizzaProduct(
                            pizza,
                            name,
                            totalPrice,
                            analyticsOptions,
                            analyticsSizeName,
                            analyticsFlavorName
                        );

                        goFish({
                            api: 'getproductlist',
                            data: { localguid: this.dominosStore.localStore.localId }
                        }).then((response: any) => {
                            const productFromList = response.Status && response.Product 
                                ? response.Product.find((p: any) => p.Id === pizza.Id)
                                : null;
                            const productTags = createTagsString(productFromList?.Tags);

                    newDataLayerPush({
                                eventName: "add_to_cart",
                                ecommerce: {
                                    currency: 'PLN',
                                    value: totalPrice,
                                    items: [createGA4LayerPizzaProduct(
                                        id,                                                          // id
                                        name,                                                        // name
                                        productIndex,                                               // index (z view_item_list/select_item lub fallback)
                                        'Dominos',                                                   // item_brand
                                        productTypes[1],                                             // item_category
                                        isCartPage() ? 'Cart' : itemListName,                        // item_list_name (z CartId lub fallback)
                                        getItemCategory2(categoryGuid, addedProduct.Data.DocumentName), // item_category2
                                        productTags || '',                                           // item_category3 (tagi: vege, hot, etc.)
                                        pizzaProduct.variant,                                        // item_variant
                                        price,                                                       // price
                                        quantity                                                     // count
                                    )],
                                    minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                                },
                            });
                            
                            if (isCartPage()) {
                                sendViewCartEvent(this);
                            }
                        }).catch(() => {
                            const itemListNameForFallback = addedProduct.Data.CartId 
                                ? (sessionStorage.getItem(`cart_${addedProduct.Data.CartId}_item_list_name`) || itemListNameFromProduct)
                                : itemListNameFromProduct;
                            
                            newDataLayerPush({
                                eventName: "add_to_cart",
                                ecommerce: {
                                    currency: 'PLN',
                                    value: totalPrice,
                                    items: [createGA4LayerPizzaProduct(
                                        id,                                                          // id
                                        name,                                                        // name
                                        productIndex,                                                // index (z view_item_list/select_item lub fallback)
                                        'Dominos',                                                   // item_brand
                                        productTypes[1],                                             // item_category
                                        isCartPage() ? 'Cart' : itemListNameForFallback,             // item_list_name (z CartId lub fallback)
                                        getItemCategory2(categoryGuid, addedProduct.Data.DocumentName), // item_category2
                                        '',                                                          // item_category3 (fallback)
                                        pizzaProduct.variant,                                        // item_variant
                                        price,                                                       // price
                                        quantity                                                     // count
                                    )],
                                    minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                                }
                            });
                            
                            if (isCartPage()) {
                                sendViewCartEvent(this);
                            }
                        });
                    }

                    return '';
                } else {
                    const msg: string = resp.Message || getAppDefaultMessage('errors.default');
                    showInfoPopup({
                        subtitle: getAppDefaultMessage('errors.popupHeader'),
                        text: msg,
                        button: getAppDefaultMessage('errors.popupBtn')
                    });
                    return msg;
                }
            }, this.manageCartResponseFail);
        }
    };

    /**
     *
     *
     * @memberof CartStore
     */
    @action addCreatorToCart = (
        name: string,
        totalPrice: number,
        creator: CartCreatorProduct,
        nameForCreatorAnalytics: string,
        analyticsNames: string[],
        analyticsSizeNames: string[],
        analyticsFlavorNames: string[],
        analyticsOptionsBundle: CreatorOptionsAnalytics,
    ) => {
        this.working = true;
        return goFish({
            api: 'addcreator',
            data: creator
        }).then((resp: CartResponse) => {
            this.manageCartResponse(resp);
            if (resp.Status) {
                const addedPizza = resp.CartCreators.find(
                    prod => prod.Id === creator.Id
                );

                prepareProductsForInsider({
                    products: [
                        {
                            Type: 99,
                            Data: addedPizza,
                        }
                    ],
                    localguid: this.dominosStore.localStore.localId,
                }).then(prods => {
                    // item_added_to_cart
                    window.InsiderQueue = [];
                    window.InsiderQueue.push({
                        type: 'currency',
                        value: 'PLN'
                    });
                    window.InsiderQueue.push({
                        type: 'add_to_cart',
                        value: {
                            ...prods[0],
                            name: nameForCreatorAnalytics,
                            taxonomy: ['pizza_creator'],
                        }
                    });
                    window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
                });

                this.generateActiveProduct(creator.Id, name, totalPrice, creator.Count);
                dataLayerPush(
                    'ee_add',
                    {},
                    {
                        add: {
                            actionField: {
                                list: this.currentMenuCategory
                            },
                            products: [
                                createLayerCreatorProduct(
                                    creator,
                                    nameForCreatorAnalytics,
                                    totalPrice,
                                    analyticsOptionsBundle,
                                    analyticsNames,
                                    analyticsSizeNames,
                                    analyticsFlavorNames
                                )
                            ]
                        }
                    }
                );

                const selectedProduct = createLayerCreatorProduct(creator,nameForCreatorAnalytics,totalPrice,analyticsOptionsBundle,analyticsNames,analyticsSizeNames,analyticsFlavorNames)
                
                const storedIndex = sessionStorage.getItem(`product_${creator.Id}_index`);
                const productIndex = storedIndex ? parseInt(storedIndex, 10) : 1;
                
                const storedItemListName = sessionStorage.getItem(`product_${creator.Id}_item_list_name`);
                
                // kreator
                const addedCreator = this.products.find(p => p.Data.Id === creator.Id);
                const categoriesGuid = addedCreator && 'CategoriesGuid' in addedCreator.Data 
                    ? addedCreator.Data.CategoriesGuid 
                    : [];
                const categoryGuid = categoriesGuid && categoriesGuid.length > 0 
                    ? categoriesGuid[0] 
                    : null;
                
                const itemListNameFromProduct = storedItemListName || selectedProduct.category;
                
                if (addedCreator && addedCreator.Data.CartId && itemListNameFromProduct) {
                    sessionStorage.setItem(`cart_${addedCreator.Data.CartId}_item_list_name`, itemListNameFromProduct);
                }
                
                const itemListName = addedCreator && addedCreator.Data.CartId 
                    ? (sessionStorage.getItem(`cart_${addedCreator.Data.CartId}_item_list_name`) || itemListNameFromProduct)
                    : itemListNameFromProduct;

                newDataLayerPush({
                    eventName: "add_to_cart",
                    ecommerce: {
                        currency: 'PLN',
                        value: totalPrice,
                        items: [{
                            'item_id': creator.Id,
                            'item_name': selectedProduct.name,
                            'index': productIndex,
                            'item_brand': 'Dominos',
                            'item_list_name': itemListName,
                            'item_category': selectedProduct.category,
                            'item_category2': getItemCategory2(categoryGuid, addedCreator?.Data?.DocumentName),
                            'item_variant': selectedProduct.variant,
                            'price': selectedProduct.price,
                            'quantity': selectedProduct.quantity,
                        }],
                        minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                    }
                });
                
                if (isCartPage()) {
                    sendViewCartEvent(this);
                }

                
                return '';
            } else {
                const msg: string = resp.Message || getAppDefaultMessage('errors.default');
                showInfoPopup({
                    subtitle: getAppDefaultMessage('errors.popupHeader'),
                    text: msg,
                    button: getAppDefaultMessage('errors.popupBtn')
                });
                return msg;
            }
        }, this.manageCartResponseFail);
    };

    /**
     * Edit pizza
     * Returned message means error
     *
     * @param {CartPizzaProductEdit} pizza
     * @memberof CartStore
     */
    @action editPizzaInCart = (
        pizza: CartPizzaProductEdit
    ): Promise<{ Message: string; CartId: string }> => {
        this.working = true;
        return goFish({
            api: 'editpizza',
            data: { ...pizza }
        })
            .then(this.manageEditResponse, this.manageCartResponseFail)
            .then(errorMsg => {
                const p = this.findEditedPizza(pizza, this.pizzas);
                return { Message: errorMsg, CartId: p ? p.Data.CartId : '' };
            });
    };

    /**
     *
     *
     * @memberof CartStore
     */
    @action editCreatorInCart = (creator: CartCreatorProduct) => {
        this.working = true;
        return goFish({
            api: 'editcreator',
            data: creator
        }).then(this.manageEditResponse, this.manageCartResponseFail);
    };

    /**
     *
     *
     * @memberof CartStore
     */
    @action addPromotionToCart = (
        name: string,
        promotion: CartCouponProduct,
        analyticsDataObj: AnalyticsStepObj[]
    ): Promise<string> => {
        this.working = true;
        return goFish({
            api: 'addcoupon',
            data: { ...promotion }
        }).then((resp: CartResponse) => {
            this.manageCartResponse(resp);
            if (resp.Status) {
                for (let i = resp.CartCoupons.length - 1; i > -1; i--) {
                    if (resp.CartCoupons[i].Id === promotion.Id) {
                        resp.CartCoupons[i].CartGroups.map(group => {
                            group.CartPizzas.map(pizza => {
                                recombeeAddToCart(pizza.DocumentName, pizza.Count, null);
                            });
                            group.CartProducts.map(product => {
                                recombeeAddToCart(product.DocumentName, product.Count, null);
                            });
                        });
                        break;
                    }
                }
                this.generateActiveProduct(promotion.Id, name, 0, 1);
                //get the added cart element
                const actualCart = resp.CartCoupons.find(coupon => {
                    return coupon.Id === promotion.Id;
                });
                //get the proper element
                const addedCoupon = this.cartProduct(actualCart.CartId);
                if (addedCoupon) {
                    prepareProductsForInsider({
                        products: this.products,
                        localguid: this.dominosStore.localStore.localId,
                    }).then(prods => {
                        // item_added_to_cart
                        window.InsiderQueue = [];
                        window.InsiderQueue.push({
                            type: 'currency',
                            value: 'PLN'
                        });
                        window.InsiderQueue.push({
                            type: 'add_to_cart',
                            value: {
                                total: this.totalSum,
                                items: prods
                            }
                        });
                        window.Insider &&
                            window.Insider.eventManager.dispatch('init-manager:re-initialize');
                    });
                    dataLayerPush(
                        'ee_add',
                        {},
                        {
                            add: {
                                actionField: {
                                    list: this.currentMenuCategory
                                },
                                products: [
                                    createLayerPromotionProduct(promotion, name, analyticsDataObj)
                                ]
                            }
                        }
                    );
                    
                    // promotion
                    const storedIndex = sessionStorage.getItem(`product_${promotion.Id}_index`);
                    const parsedStoredIndex = storedIndex ? parseInt(storedIndex, 10) : NaN;
                    const productIndex = Number.isNaN(parsedStoredIndex) ? 1 : parsedStoredIndex;
                    const prodToAddToCart = this.products.find(prod => prod.Data.Id === promotion.Id);

                    goFish({
                        api: 'getproductlist',
                        data: { localguid: this.dominosStore.localStore.localId }
                    }).then((response: any) => {
                        const productFromList = response.Status && response.Product 
                            ? response.Product.find((p: any) => p.Id === promotion.Id)
                            : null;
                        
                        const categoryGuid = productFromList?.CategoryGuid || null;

                        newDataLayerPush({
                            eventName: "add_to_cart",
                            ecommerce: {
                                currency: 'PLN',
                                value: prodToAddToCart.Data.Sum,
                                items: [{
                                    'item_id': promotion.Id,
                                    'item_name': name,
                                    'index': productIndex,
                                    'item_brand': 'Dominos',
                                    'item_list_name': categoryGuid ? getCategoryNameByGuid(categoryGuid) : (this.currentMenuCategory || 'promocje'),
                                    'item_category': productTypes[2],
                                    /* zmienione 19.01.2026 */
                                    'item_category2': getItemCategory2(categoryGuid, prodToAddToCart.Data.DocumentName),
                                    /* zmienione 19.01.2026 */
                                    'item_variant':
                                        createLayerPromotionProduct(promotion, name, analyticsDataObj).variant,
                                    'price': prodToAddToCart.Data.Price,
                                    'quantity': promotion.Count,
                                    'coupon': name,
                                }],
                                minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                            }
                        });
                        
                        if (isCartPage()) {
                            sendViewCartEvent(this);
                        }
                    }).catch(() => {
                        newDataLayerPush({
                            eventName: "add_to_cart",
                            ecommerce: {
                                currency: 'PLN',
                                value: prodToAddToCart.Data.Sum,
                                items: [{
                                    'item_id': promotion.Id,
                                    'item_name': name,
                                    'index': productIndex,
                                    'item_brand': 'Dominos',
                                    'item_list_name': this.currentMenuCategory || 'promocje',
                                    'item_category': productTypes[2],
                                    /* zmienione 19.01.2026 */
                                    'item_category2': getItemCategory2(null, prodToAddToCart.Data.DocumentName),
                                    /* zmienione 19.01.2026 */
                                    'item_variant':
                                        createLayerPromotionProduct(promotion, name, analyticsDataObj).variant,
                                    'price': prodToAddToCart.Data.Price,
                                    'quantity': promotion.Count,
                                }],
                                minimalOrderValue: dominosStore.cartStore.MinimalOrderValue
                            }
                        });
                        
                        if (isCartPage()) {
                            sendViewCartEvent(this);
                        }
                    });
                }
                return '';
            } else {
                const msg: string = resp.Message || getAppDefaultMessage('errors.default');
                showInfoPopup({
                    subtitle: getAppDefaultMessage('errors.popupHeader'),
                    text: msg,
                    button: getAppDefaultMessage('errors.popupBtn')
                });
                return msg;
            }
        }, this.manageCartResponseFail);
    };

    /**
     *
     *
     * @memberof CartStore
     */
    @action editPromotionInCart = (
        promotion: CartCouponProductEdit,
        groupId?: string,
        pizza?: CartPizzaProductEdit
    ): Promise<{ Message: string; CartId: string }> => {
        this.working = true;
        return goFish({
            api: 'editcoupon',
            data: { ...promotion }
        })
            .then(this.manageEditResponse, this.manageCartResponseFail)
            .then(errorMsg => {
                const rObj = { Message: errorMsg, CartId: '' };
                if (groupId) {
                    const p = this.findEditedPizzaInPromotion(promotion, groupId, pizza);
                    if (p) {
                        rObj.CartId = p.Data.CartId;
                    }
                }
                return rObj;
            });
    };

    /**
     * Used to verify promotion by ID
     */
    checkUpsellPromotion = (id: string): Promise<boolean> => {
        return goFish({
            api: 'useupsellpromotion',
            data: { promotionguid: id }
        })
        .then((response) => {
            if (!response.Status) {
                showInfoPopup({
                    text: response.Message || getAppDefaultMessage('errors.server')
                });
            }
            return response.Status
        }, err => {
            showInfoPopup({
                text: err.Message || getAppDefaultMessage('errors.server')
            });
            return false;
        });
    };

    /**
     *
     * @param resp
     */
    manageEditResponse = (resp: CartResponse) => {
        this.manageCartResponse(resp);
        if (resp.Status) {
            return '';
        } else {
            const msg: string = resp.Message || getAppDefaultMessage('errors.default');
            showInfoPopup({
                subtitle: getAppDefaultMessage('errors.popupHeader'),
                text: msg,
                button: getAppDefaultMessage('errors.popupBtn')
            });
            return msg;
        }
    };

    /**
     * Compares pizza
     *
     * @param {CartPizzaProduct} pizza
     * @returns {AppCartPizzaProduct}
     * @memberof CartStore
     */
    findEditedPizza = (
        pizza: CartPizzaProduct,
        pizzas: AppCartPizzaProduct[]
    ): AppCartPizzaProduct | undefined => {
        // Count of pizzas is not checked because of merging made by back-end
        const similarPizzas = pizzas
            .filter(p => p.Data.PulseCode === pizza.FlavorPulseCode)
            // Should be same quantity of available toppings
            .filter(p => p.Data.Options.length == pizza.Options.length)
            // Toppings should be exactly the same
            .filter(p =>
                p.Data.Options.every(o => {
                    return pizza.Options.find(po => po.Id === o.Id && po.Count === o.Count)
                        ? true
                        : false;
                })
            );
        // Return only one (should be one ;)
        if (similarPizzas.length) {
            return similarPizzas[0];
        }
    };

    findEditedPizzaInPromotion = (
        promo: CartCouponProduct,
        groupId: string,
        pizza: CartPizzaProduct
    ): AppCartPizzaProduct | undefined => {
        // Get same promotions
        const similarPromo = this.promotions.filter(
            pr => pr.Data.CartGroups.length == promo.CartCoupons.length && pr.Data.Id === promo.Id
        );
        // Grab pizzas
        if (similarPromo.length) {
            // Find group
            let editedPizza;
            similarPromo.find(pr => {
                return pr.Data.CartGroups.find(gr => {
                    if (gr.GroupId === groupId) {
                        const eP = this.findEditedPizza(
                            pizza,
                            gr.CartPizzas.map(p => ({ Type: 1, Data: { ...p } }))
                        );
                        // Pizza found
                        if (eP) {
                            editedPizza = eP;
                            return true;
                        }
                    }
                });
            });
            // Return whatever was found or undefined
            return editedPizza;
        }
    };

    @action addOrderToCart = (
        name: string,
        id: string,
        order: CartOrderProduct,
        orderForAnalytics: AppCartProduct[]
    ) => {
        this.working = true;
        return goFish({
            api: 'addorder',
            data: { ...order }
        }).then((resp: CartResponse) => {
            
            this.manageCartResponse(resp);
            if (resp.Status) {
                this.dominosStore.localStore.getCurrentLocal().then(() => {
                    const localguid = this.dominosStore.localStore.localId;
                    prepareProductsForInsider({
                        products: orderForAnalytics,
                        localguid,
                    }).then(prods => {
                        // item_added_to_cart,only one product will be added due to the Insider side. Bernard from Insider said we can proceed with the default behavior
                        window.InsiderQueue = [];
                        prods.forEach((prod) => {
                            window.InsiderQueue.push({
                                type: 'currency',
                                value: 'PLN'
                            });
                            window.InsiderQueue.push({
                                type: 'add_to_cart',
                                value: prod
                            });
                            window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
                        });
                    });
                });
                dataLayerPush(
                    'ee_add',
                    {},
                    {
                        add: {
                            actionField: {
                                list: this.currentMenuCategory
                            },
                            products: createLayerProducts(orderForAnalytics)
                        }
                    }
                );

                console.log("products 5:", createLayerProducts(orderForAnalytics));

                this.generateActiveProduct(id, name, 0, 1);

                if (resp.Message) {
                    showInfoPopup({ text: resp.Message });
                }
                return '';
            }

            return resp.Message || getAppDefaultMessage('errors.default');
        }, this.manageCartResponseFail);
    };

    /**
     * Used by cloud message after product quantity modification.
     * Price is summ price for all products that should be displayed (not price of the product)
     *
     * @param {string} Id
     * @param {string} Name
     * @param {number} Price
     * @param {number} Quantity
     * @memberof CartStore
     */
    @action generateActiveProduct = (Id: string, Name: string, Price: number, Quantity: number) => {
        clearTimeout(this.activeProductTimeout);

        this.activeProduct = {
            Time: Date.now(),
            Id,
            Name,
            Price,
            Quantity
        };

        this.activeProductTimeout = window.setTimeout(
            action(() => {
                this.activeProduct = null;
            }),
            5000
        );
    };

    /**
     * Returns quantity of provided product (by CartId) in cart
     *
     * @param {string} CartId
     * @returns {number}
     * @memberof CartStore
     */
    cartQuantity = (CartId: string): number => {
        const q = this.products.find(p => p.Data.CartId === CartId);
        return q?.Data.Count || 0;
    };

    /**
     * Returns quantity of all product with this id in cart
     *
     * @param {string} id
     * @returns {number}
     * @memberof CartStore
     */
    cartQuantityById = (id: string): number => {
        return this.products.reduce((q, p) => (p.Data.Id === id ? q + p.Data.Count : q), 0);
    };

    /**
     * Get cart product by CartId
     * Resolving will be postponed until cart is loaded if needed
     *
     * @memberof CartStore
     */
    getCartProduct = async (cartId: string): Promise<AppCartProduct> => {
        return new Promise((resolve, reject) => {
            const checkFunc = () => {
                if (this.loading) {
                    if (this.getProductCounter > 5) {
                        this.getProductCounter = 0;
                        reject();
                    } else {
                        this.getProductCounter++;
                        setTimeout(() => {
                            checkFunc();
                        }, 300);
                    }
                } else {
                    this.getProductCounter = 0;
                    resolve(this.cartProduct(cartId));
                }
            };

            checkFunc();
        });
    };

    /**
     * Returns cart product by CartId
     *
     * @param {string} cartId
     * @returns {number}
     * @memberof CartStore
     */
    private cartProduct(cartId: string) {
        // find pizza in promotions to be able edit it in configurator
        const promoPizzas: AppCartPizzaProduct[] = this.products
        .filter(prod => prod.Type === 2)
        .flatMap(prod => 
            prod.Data.CartGroups.flatMap(group =>
                group.CartPizzas.map(pizza => ({ Type: 1, Data: pizza }))
            )
        );

    const allProducts = [...this.products, ...promoPizzas];

    return allProducts.find(product => product.Data.CartId === cartId);
    }

    @action activatePromotionMode = () => {
        if (!this.configuratorPromotionMode) {
            this.configuratorPromotionMode = true;
        }
    };

    @action releasePromotionMode = () => {
        if (this.configuratorPromotionMode) {
            this.configuratorPromotionMode = false;
        }
    };

    saveCreatorId = (id: string) => {
        this.creatorId = id;
    };

    isProductHidden = (name: string) => {
        return this.hiddenFromOutsideProducts.find(p => p === name);
    };

    // Computed values

    @computed get totalOld() {
        return this.products.reduce(
            // (pV, cV) => pV + (cV.Data.OldPrice || cV.Data.Price) * cV.Data.Count,
            (pV, cV) => pV + (cV.Data.OldPrice ? cV.Data.OldPrice * cV.Data.Count : cV.Data.Sum),
            0
        );
    }

    @computed get totalSave() {
        return this.products.reduce(
            (pV, cV) =>
                pV +
                (cV.Data.OldPrice > 0 ? (cV.Data.OldPrice - cV.Data.Price) * cV.Data.Count : 0),
            0
        );
    }

    @computed get totalCount() {
        // hiding packages in counter
        const packages = this.products.filter( p => {
            if (this.Packages && p.Data.PulseCode && this.Packages.some(pack => p.Data.PulseCode === pack.Id)) {
                return p.Data.Count
            }
        })
        let packagesCount = 0;
        packages.forEach(pckg => {
            packagesCount += pckg.Data.Count;
            return packagesCount
        })
        return (this.products.reduce((pV, cV) =>
        pV + cV.Data.Count,
        0) - packagesCount);
    }

    @computed get promotions() {
        return this.products.filter(p => p.Type === 2) as AppCartCouponProduct[];
    }

    @computed get simpleproducts() {
        return this.products.filter(p => p.Type === 98) as AppCartSimpleProduct[];
    }

    @computed get pizzas() {
        return this.products.filter(p => p.Type === 1) as AppCartPizzaProduct[];
    }

    @computed get pizzasandproducts() {
        return this.products.filter(p => p.Type === 1 || p.Type === 98);
    }

    @computed get creators() {
        return this.products.filter(p => p.Type === 99) as AppCartCreatorProduct[];
    }

    @computed get notpromotions() {
        return this.products.filter(p => p.Type !== 2);
    }

    @computed get cartIdArray() {
        return this.products.map(p => p.Data.CartId);
    }
}
